import { render, staticRenderFns } from "./Unlink.vue?vue&type=template&id=2ac0906d&scoped=true"
import script from "./Unlink.vue?vue&type=script&lang=ts"
export * from "./Unlink.vue?vue&type=script&lang=ts"
import style0 from "./Unlink.vue?vue&type=style&index=0&id=2ac0906d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0906d",
  null
  
)

export default component.exports